/**
 * localStorage 读写工具，统一处理需要 JSON 序列化保存的本地数据。
 */

// 设置 localStorage
export const setStorage = function(key, obj) {
    let json = JSON.stringify(obj);
    window.localStorage.setItem(key, json)
};

// 获取 localStorage
export const getStorage = function(key) {
  const str = window.localStorage.getItem(key);
  if (!str) {
      return null
    }
    return JSON.parse(str)
};

// 移除 localStorage
export const removeStorage = function(key) {
    window.localStorage.removeItem(key)
};
